export * from './src/administration-view.component';
